import React from 'react'
import { NavLink } from 'react-router-dom';
import { Menu } from 'semantic-ui-react';
import './index.scss';
import { USER_PERMISSIONS } from 'dyl-components';
import RestrictedView from 'shared/RestrictedView';


const Navigation = ({ links }) => {

    const navItems = [...links ];

    return (
        <Menu size='small' borderless pointing secondary stackable>
            {navItems.map(item => {
                const name = (item.group_name === 'person') ? 'contact' : item.group_name
                return (
                <RestrictedView type='disabled' userPermission={USER_PERMISSIONS.DATA_CUSTOMIZATION_VIEW}>
                    <Menu.Item as={NavLink}
                        name={`${item.label}`}
                        to={`/settings/data-customization/${name}`}
                        id={item.id}
                        disabled={item?.disabled} 
                    />
                </RestrictedView>
                )
            })}
        </Menu>
    )
};

export default Navigation;


